export const ACTIONABLE = "actionable";
export const INFORMATIVE = "informative";
